module.exports = __webpack_public_path__ + "static/img/mv.8ea7a65e.svg";